<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="breadcrumb-title border-0 mb-3 mt-1">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
        >
          <div class="d-flex align-items-center">
            <mat-icon color="primary">dashboard_customize</mat-icon>
            <p class="ms-2 mb-0">{{ "APPLICATIONS.TITLE" | translate }}</p>
          </div>
          <div class="p-0 m-0">
            <app-list-header [$parent]="getSelf()"></app-list-header>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-md-12">
      <div class="card" style="min-height: 480px">
        <div class="card-body">
          <!-- Tab Content -->
          <div class="row">
            <div class="col-md-12 px-1">
              <div class="tab-content mt-2" id="pills-tabContent">
                <!-- Main Applications Tab -->
                <div
                  class="tab-pane fade"
                  [class.show]="!isArchiveActive"
                  [class.active]="!isArchiveActive"
                  id="pills-main"
                  role="tabpanel"
                  aria-labelledby="pills-main-tab"
                >
                  <div class="mb-3">
                    <div>
                      <p
                        *ngIf="
                          form['searchError'] == false && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="success"
                        />
                      </p>
                      <p
                        *ngIf="
                          form['searchError'] == true && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="danger"
                        />
                      </p>
                    </div>

                    <div class="table-container mb-3">
                      <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ "COMMON.SNO" | translate }}
                              </th>
                              <th class="text-nowrap">
                                {{ "COMMON.NAME" | translate }}
                              </th>
                              <th>{{ "COMMON.ACTIONS" | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let e of form.list; let i = index">
                              <td class="text-center">{{ pageIndex(i) }}</td>

                              <!-- Name + Logo -->
                              <td class="align-middle">
                                <div class="d-flex align-items-center">
                                  <!-- Logo Card -->
                                  <div class="me-3">
                                    <div
                                      class="p-1 border rounded d-flex justify-content-center align-items-center"
                                      style="
                                        width: 40px;
                                        height: 40px;
                                        overflow: hidden;
                                      "
                                    >
                                      <a
                                        [href]="getDoc(e['logo'])"
                                        target="_blank"
                                        class="d-block"
                                        [matTooltip]="e.name"
                                        matTooltipPosition="above"
                                      >
                                        <img
                                          [src]="getDocThumbnail(e['logo'])"
                                          [alt]="
                                            e.name ||
                                            ('COMMON.IMAGE_PREVIEW' | translate)
                                          "
                                          class="w-100 h-100"
                                          style="object-fit: cover"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <!-- Application Name -->
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color="primary"
                                        class="p-0"
                                        style="font-size: 14px; height: auto"
                                        >dashboard_customize</mat-icon
                                      >
                                      <p style="font-weight: 500" class="mb-0">
                                        {{ truncate(e.name, 30) }}
                                      </p>
                                    </div>
                                    <!-- App URL -->
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        class="p-0 text-muted"
                                        style="font-size: 14px; height: auto"
                                        >link</mat-icon
                                      >
                                      <small
                                        class="text-truncate text-muted"
                                        style="max-width: 180px"
                                      >
                                        {{ e.appUrl }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <!-- Actions -->
                              <td>
                                <div class="d-flex gap-2">
                                  <!-- Role Button -->
                                  <button
                                    *ngIf="hasAccess('Role')"
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.ROLES' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#appRoleModal"
                                    (click)="setApp(e, 'app-role')"
                                  >
                                    <small class="me-1">{{
                                      "APPLICATIONS.ROLES" | translate
                                    }}</small>
                                    <mat-icon>group</mat-icon>
                                  </button>

                                  <!-- Role Access Button -->
                                  <button
                                    *ngIf="hasAccess('Role Access')"
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.ACCESS' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#appRoleUsecaseModal"
                                    (click)="setApp(e, 'app-role-usecase')"
                                  >
                                    <mat-icon>lock</mat-icon>
                                    <small>{{
                                      "APPLICATIONS.ACCESS" | translate
                                    }}</small>
                                  </button>

                                  <!-- Menu Button -->
                                  <button
                                    *ngIf="hasAccess('Menu')"
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.MENU' | translate
                                    "
                                    (click)="setApp(e, 'app-menus')"
                                    [routerLink]="['/menuslist/' + e.id]"
                                  >
                                    <mat-icon>menu_open</mat-icon>
                                    <small>{{
                                      "APPLICATIONS.MENU" | translate
                                    }}</small>
                                  </button>

                                  <!-- App Users Button -->
                                  <button
                                    *ngIf="hasAccess('App Users')"
                                    mat-stroked-button
                                    color="primary"
                                    matTooltipPosition="above"
                                    [matTooltip]="
                                      'APPLICATIONS.USERS' | translate
                                    "
                                    [routerLink]="['/applicationUser/' + e.id]"
                                  >
                                    <mat-icon>group_add</mat-icon>
                                    <small>{{
                                      "APPLICATIONS.USERS" | translate
                                    }}</small>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div>
                      <app-list-header [$parent]="getSelf()"></app-list-header>
                    </div>
                  </div>
                </div>

                <!-- Archived Applications Tab -->
                <div
                  class="tab-pane fade"
                  [class.show]="isArchiveActive"
                  [class.active]="isArchiveActive"
                  id="pills-archived"
                  role="tabpanel"
                  aria-labelledby="pills-archived-tab"
                >
                  <div class="mb-3">
                    <div>
                      <p
                        *ngIf="
                          form['searchError'] == false && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="success"
                        />
                      </p>
                      <p
                        *ngIf="
                          form['searchError'] == true && form['searchMessage']
                        "
                      >
                        <app-ncs-alert
                          [message]="form['searchMessage']"
                          type="danger"
                        />
                      </p>
                    </div>

                    <div class="table-container mb-3">
                      <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ "COMMON.SNO" | translate }}
                              </th>
                              <th class="text-nowrap">
                                {{ "COMMON.NAME" | translate }}
                              </th>
                              <th>{{ "COMMON.ACTIONS" | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let e of form.archivedlist; let i = index"
                            >
                              <td class="text-center">
                                {{ pageIndex(i) }}
                              </td>

                              <!-- Archived Picture and Name with URL -->
                              <td>
                                <div class="d-flex align-items-center">
                                  <div class="me-3">
                                    <div
                                      class="p-1 border rounded"
                                      style="
                                        width: 40px;
                                        height: 40px;
                                        overflow: hidden;
                                      "
                                    >
                                      <a
                                        [href]="getDoc(e['logo'])"
                                        target="_blank"
                                        class="d-block h-100"
                                        [matTooltip]="e.name"
                                        matTooltipPosition="above"
                                      >
                                        <img
                                          [src]="getDocThumbnail(e['logo'])"
                                          [alt]="
                                            e.name ||
                                            ('COMMON.IMAGE_PREVIEW' | translate)
                                          "
                                          class="w-100 h-100"
                                          style="object-fit: cover"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        color="primary"
                                        class="p-0 me-1"
                                        style="font-size: 14px; height: auto"
                                        >dashboard_customize</mat-icon
                                      >
                                      <p style="font-weight: 500" class="mb-0">
                                        {{ e.name }}
                                      </p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                      <mat-icon
                                        class="p-0 me-1 text-muted"
                                        style="font-size: 14px; height: auto"
                                        >link</mat-icon
                                      >
                                      <small
                                        class="text-truncate text-muted"
                                        style="max-width: 180px"
                                      >
                                        {{ e.appUrl }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <!-- Retrieve Action -->
                              <td>
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'APPLICATIONS.RETRIEVE' | translate
                                  "
                                  matTooltipPosition="above"
                                  (click)="retrieve(e.id)"
                                >
                                  <mat-icon>unarchive</mat-icon>
                                  <span class="ms-1">{{
                                    "APPLICATIONS.RETRIEVE" | translate
                                  }}</span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <app-list-header [$parent]="getSelf()"></app-list-header>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Application Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
          (click)="imagePreviewReset()"
        ></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>

          <!-- Name Field -->
          <div class="row mb-3">
            <div class="col"></div>
            <label for="name" class="col col-form-label"
              >{{ "COMMON.NAME" | translate }} :
            </label>
            <div class="col-sm-7">
              <input
                (input)="checkValue($event)"
                id="name"
                name="name"
                [placeholder]="'COMMON.NAME' | translate"
                type="text"
                class="form-control form-control-sm"
                required
                [(ngModel)]="form.data['name']"
              />
              <span style="color: red">{{ form.inputerror["name"] }} </span>
            </div>
            <div class="col"></div>
          </div>

          <!-- URL Field -->
          <div class="row mb-3">
            <div class="col"></div>
            <label for="appUrl" class="col col-form-label"
              >{{ "COMMON.URL" | translate }} :</label
            >
            <div class="col-sm-7">
              <input
                id="appUrl"
                name="appUrl"
                [placeholder]="'COMMON.URL_PLACEHOLDER' | translate"
                type="text"
                class="form-control form-control-sm"
                required
                [(ngModel)]="form.data['appUrl']"
              />
              <span style="color: red">{{ form.inputerror["appUrl"] }} </span>
            </div>
            <div class="col"></div>
          </div>

          <!-- Domain Field -->
          <div class="row mb-3 d-flex">
            <div class="col"></div>
            <label
              for="domainUrl"
              class="col col-form-label"
              style="margin-left: -14px"
              >{{ "COMMON.DOMAIN" | translate }} :</label
            >
            <div class="col-sm-7">
              <input
                id="domainUrl"
                name="domainUrl"
                [placeholder]="'COMMON.DOMAIN_PLACEHOLDER' | translate"
                type="url"
                class="form-control form-control-sm"
                [(ngModel)]="form.data['domainUrl']"
              />
              <span style="color: red"
                >{{ form.inputerror["domainUrl"] }}
              </span>
            </div>
            <div class="col ps-0">
              <span
                ncsTooltip
                class="d-flex float-start"
                [title]="'COMMON.DOMAIN_TOOLTIP' | translate"
              >
                <i
                  class="bi bi-info-circle fs-6 ms-2 mt-1 text-secondary cursor"
                ></i>
              </span>
            </div>
          </div>

          <!-- Code Field (readonly for existing apps) -->
          <div class="row mb-3" *ngIf="form.data['id'] > 0">
            <div class="col"></div>
            <label for="code" class="col col-form-label"
              >{{ "COMMON.CODE" | translate }} :</label
            >
            <div class="col-sm-7">
              <input
                [disabled]="true"
                [(ngModel)]="form.data['code']"
                type="text"
                class="form-control form-control-sm"
                id="code"
                name="code"
                [placeholder]="'COMMON.CODE' | translate"
              />
            </div>
            <div class="col"></div>
          </div>

          <!-- Status Field -->
          <div class="row mb-3">
            <div class="col"></div>
            <label for="status" class="col col-form-label"
              >{{ "COMMON.STATUS" | translate }} :</label
            >
            <div class="col-sm-7">
              <select
                [(ngModel)]="form.data['status']"
                class="form-select form-select-sm"
                id="status"
                name="status"
              >
                <option value="undefined" disabled selected>
                  {{ "COMMON.SELECT" | translate }}
                </option>
                <option value="private">
                  {{ "APPLICATIONS.STATUS.PRIVATE" | translate }}
                </option>
                <option value="public">
                  {{ "APPLICATIONS.STATUS.PUBLIC" | translate }}
                </option>
                <option value="draft">
                  {{ "APPLICATIONS.STATUS.DRAFT" | translate }}
                </option>
              </select>
            </div>
            <div class="col"></div>
          </div>

          <!-- Logo Upload (for existing apps) -->
          <div class="row mb-3" *ngIf="form.data['id'] > 0">
            <div class="col"></div>
            <label for="logo" class="col col-form-label"
              >{{ "COMMON.LOGO" | translate }} :</label
            >
            <div class="col-sm-7">
              <input
                class="form-control"
                id="logo"
                #file
                type="file"
                accept="image/*"
                name="logo"
                (change)="
                  file.files && onFileChanged($event, 'logo', form.data['logo'])
                "
              />
              <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
            </div>
            <div class="col"></div>
          </div>

          <!-- Logo Preview -->
          <div class="row mb-3" *ngIf="form.data['id'] > 0">
            <div class="col"></div>
            <label for="preview" class="col col-form-label"
              >{{ "COMMON.PREVIEW" | translate }} :</label
            >
            <div class="col-sm-7">
              <img
                [src]="
                  imagePreview == null
                    ? getDocThumbnail(form.data['logo'])
                    : imagePreview
                "
                [alt]="'COMMON.IMAGE_PREVIEW' | translate"
                class="img-thumbnail"
                style="max-width: 200px; max-height: 200px"
              />
            </div>
            <div class="col"></div>
          </div>

          <!-- Enable User Signup -->
          <div
            class="row mb-3 d-flex justify-content-center align-items-center"
            *ngIf="form.data['id'] > 0"
          >
            <div class="col"></div>
            <label
              for="enableUserSignup"
              class="col col-form-label d-flex justify-content-end"
            >
              <input
                [(ngModel)]="form.data['enableUserSignup']"
                type="checkbox"
                class="form-check-input"
                id="enableUserSignup"
                name="enableUserSignup"
              />
            </label>
            <div class="col-sm-7 mt-1">
              <b>{{ "COMMON.ENABLE_USER_SIGNUP" | translate }}</b>
              <span
                ncsTooltip
                class=""
                [title]="'COMMON.ENABLE_SIGNUP_TOOLTIP' | translate"
              >
                <i
                  class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                ></i>
              </span>
            </div>
            <div class="col"></div>
          </div>

          <!-- Default Role (when signup enabled) -->
          <div
            class="row mb-3 d-flex justify-content-start"
            *ngIf="form.data['id'] > 0 && form.data['enableUserSignup']"
          >
            <div class="col"></div>
            <label for="roleId" class="col col-form-label"
              >{{ "COMMON.DEFAULT_ROLE" | translate }} :</label
            >
            <div class="col-sm-7">
              <select
                required
                class="form-select form-select-sm me-3"
                id="roleId"
                name="roleId"
                [(ngModel)]="form.data['roleId']"
              >
                <option selected disabled value="undefined">
                  {{ "COMMON.SELECT_ROLE" | translate }}
                </option>
                <option
                  *ngFor="let c of applicationRoles"
                  value="{{ c['id'] }}"
                >
                  {{ c["name"] }}
                </option>
              </select>
            </div>
            <div class="col ps-0">
              <span
                ncsTooltip
                class="d-flex float-start"
                [title]="'COMMON.DEFAULT_ROLE_TOOLTIP' | translate"
              >
                <i
                  class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                ></i>
              </span>
            </div>
          </div>

          <!-- Login Methods -->
          <div
            *ngIf="form.data['id'] > 0"
            class="row mb-3 d-flex justify-content-start"
          >
            <div class="col-2"></div>
            <label class="col-2 col-form-label"
              >{{ "COMMON.LOGIN_BY" | translate }} :</label
            >
            <div class="col-sm-7 d-flex align-items-center">
              <div class="form-check me-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="loginByEmail"
                  [(ngModel)]="form.data['loginByEmail']"
                  name="loginByEmail"
                />
                <label class="form-check-label" for="loginByEmail">{{
                  "APPLICATIONS.LOGIN_BY.EMAIL" | translate
                }}</label>
              </div>
              <div class="form-check me-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="loginByMobileNo"
                  [(ngModel)]="form.data['loginByMobileNo']"
                  name="loginByMobileNo"
                />
                <label class="form-check-label" for="loginByMobileNo">{{
                  "APPLICATIONS.LOGIN_BY.MOBILE" | translate
                }}</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="loginByLoginCode"
                  [(ngModel)]="form.data['loginByLoginCode']"
                  name="loginByLoginCode"
                />
                <label class="form-check-label" for="loginByLoginCode">{{
                  "APPLICATIONS.LOGIN_BY.LOGIN_CODE" | translate
                }}</label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          [title]="'COMMON.SAVE' | translate"
          class="btn btn-outline-primary btn-sm ml-2"
          [disabled]="!uiForm.valid || appUrlInvalid || appname"
          (click)="saveData()"
        >
          <i class="fa fa-save"></i> {{ "COMMON.SAVE" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-2"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
          (click)="imagePreviewReset()"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ "COMMON.SEARCH" | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <label for="name" class="col-sm-3 col-form-label"
            >{{ "COMMON.NAME" | translate }}:</label
          >
          <div class="col-sm-9">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                id="name"
                [placeholder]="'COMMON.ENTER_NAME' | translate"
                [(ngModel)]="form.searchParams['name']"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="applicationCode" class="col-sm-3 col-form-label"
            >{{ "COMMON.SKEY" | translate }}:</label
          >
          <div class="col-sm-9">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                id="applicationCode"
                name="applicationCode"
                [placeholder]="'COMMON.ENTER_KEY' | translate"
                [(ngModel)]="form.searchParams['applicationCode']"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          [title]="'COMMON.APPLY_FILTER' | translate"
          (click)="search()"
        >
          {{ "COMMON.APPLY_FILTER" | translate }}
        </button>
        <button
          (click)="resetSearchForm()"
          class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          [title]="'COMMON.RESET' | translate"
        >
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          [title]="'COMMON.CLOSE' | translate"
          class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App Role Modal -->
<div
  class="modal fade app-role-modal"
  id="appRoleModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_ROLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
          (click)="unSetApp()"
        ></button>
      </div>
      <div class="modal-body pt-0">
        <!-- user side selector and permission input preserved -->
        <app-app-role
          [permission]="hasPermissionData('Role')"
          [curApp]="selectApp"
          *ngIf="selectApp && editor === 'app-role'"
        ></app-app-role>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="me-3"
          data-bs-dismiss="modal"
          (click)="unSetApp()"
          [title]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!--  App Role Usecase Modal -->
<div
  class="modal fade"
  id="appRoleUsecaseModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.ROLE_ACCESS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-add-app-role-access
          [currentRoleData]="hasPermissionData('Role Access')"
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-role-usecase'"
        >
        </app-add-app-role-access>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          class="me-2"
          type="button"
          [title]="'COMMON.CLOSE' | translate"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- App User Modal -->
<div
  class="modal fade"
  id="appUserModal"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="appUserstaticBackdropLabel"
>
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "APPLICATIONS.APPLICATION_MEMBERS" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="unSetApp()"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <app-application-users
          [curApp]="selectApp"
          *ngIf="selectApp && editor == 'app-user'"
        ></app-application-users>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm ml-2"
          (click)="unSetApp()"
          data-bs-dismiss="modal"
          [title]="'COMMON.CLOSE' | translate"
        >
          <i class="fa fa-window-close"></i> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>